import axios from "axios";
import { getToken } from "@/lib/lamka";

export const WEB_API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const webApi = axios.create({ baseURL: WEB_API });
webApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
